import React from 'react';
import './barchart.scss';

// Bar chart was made of div by means of different heights and have same common width

function BarChart() {
  return (
    <div className="me-2">
      <div className="barchart d-flex align-items-end custom-gap">
        <div className="bars light-bars" style={{ height: '28px' }} />
        <div className="bars light-bars" style={{ height: '23px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />

        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '22px' }} />
        <div className="bars light-bars" style={{ height: '15px' }} />

        <div className="bars light-bars" style={{ height: '15px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '15px' }} />
        <div className="bars light-bars" style={{ height: '21px' }} />
        <div className="bars light-bars" style={{ height: '21px' }} />

        <div className="bars light-bars" style={{ height: '11px' }} />
        <div className="bars light-bars" style={{ height: '21px' }} />
        <div className="bars light-bars" style={{ height: '15px' }} />

        <div className="bars light-bars" style={{ height: '15px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '15px' }} />

        <div className="bars light-bars" style={{ height: '18px' }} />
        <div className="bars light-bars" style={{ height: '15px' }} />

        <div className="bars pink-bars" style={{ height: '14px' }} />
        <div className="bars pink-bars" style={{ height: '20px' }} />
        <div className="bars pink-bars" style={{ height: '18px' }} />

        <div className="bars pink-bars" style={{ height: '14px' }} />
        <div className="bars pink-bars" style={{ height: '20px' }} />
        <div className="bars pink-bars" style={{ height: '18px' }} />

        <div className="bars pink-bars" style={{ height: '14px' }} />
        <div className="bars pink-bars" style={{ height: '20px' }} />
        <div className="bars pink-bars" style={{ height: '18px' }} />

        <div className="bars pink-bars" style={{ height: '14px' }} />
        <div className="bars pink-bars" style={{ height: '20px' }} />
        <div className="bars pink-bars" style={{ height: '18px' }} />

        <div className="bars pink-bars" style={{ height: '14px' }} />
        <div className="bars pink-bars" style={{ height: '20px' }} />
        <div className="bars pink-bars" style={{ height: '18px' }} />

        <div className="bars pink-bars" style={{ height: '14px' }} />
        <div className="bars pink-bars" style={{ height: '20px' }} />
        <div className="bars pink-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

        <div className="bars light-bars" style={{ height: '14px' }} />
        <div className="bars light-bars" style={{ height: '20px' }} />
        <div className="bars light-bars" style={{ height: '18px' }} />

      </div>
      <hr className="bar-bottom-hr m-1" />
    </div>
  );
}

export default BarChart;
